import { Component, OnInit } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { AllBalanceUser } from 'src/app/models/allBalanceUser';
import { ClientService } from 'src/app/services/client.service';
import { Security } from 'src/app/utils/security.util';

@Component({
  selector: 'app-home',
  templateUrl: './home.page.html',
  styleUrls: ['./home.page.scss'],
})
export class HomePage implements OnInit {

  bond;
  balance: AllBalanceUser = new AllBalanceUser();
  constructor(private clientService: ClientService, private navCtrl: NavController, private modalCtrl: ModalController) { }

  ngOnInit() {
    if(Security.getCoin()){
      this.bond = Security.getCoin();
    } else {
      this.bond = '1';
      Security.setCoin(1);
    }
    this.getAllBalance();
  }

  async getAllBalance() {
    this.clientService.getAllBalance().subscribe(result => {
      this.balance.balanceReal = result.data.balanceReal;
      this.balance.balanceDolar = result.data.balanceDolar;
      this.balance.balanceSm = result.data.balanceSM;
      this.balance.balanceBs = result.data.balanceBs;
      this.balance.inOrderDolar = result.data.inOrderDolar;
      this.balance.inOrderReal = result.data.inOrderReal;
      this.balance.inOrderSm = result.data.inOrderSM;
      this.balance.inOrderBs = result.data.inOrderBs;
    });
  }

  changeBond(bond){
    this.bond = bond;
    Security.setCoin(bond);

  }

}
